// LinkedIn recommendations — Audace & Perspectives (Auriane De Potesta)
// Verbatim adapted (lightly condensed for card readability, voice preserved).

export const testimonialsFr = [
  {
    quote:
      "J'ai eu la chance de l'avoir comme coach pendant six mois. Sa remarquable capacité à s'adapter avec empathie, sa méthode de guider plutôt que de donner des réponses toutes faites, a grandement facilité la mise en œuvre des actions. Un catalyseur essentiel de ma croissance professionnelle.",
    author: "Alexandre Piorunowski",
    context: "General Manager — Fidia Pharma",
  },
  {
    quote:
      "Attentionnée dans son écoute, aux méthodes variées et redoutablement efficaces lorsqu'il s'agit de vous faire redécouvrir tous les angles de vos capacités professionnelles. 20 ans de carrière passées, je devais définir avec assurance les 20 années suivantes — Auriane y a été d'une aide inestimable.",
    author: "Bruno Latanicki",
    context: "Directeur Projet Digital — Air Liquide",
  },
  {
    quote:
      "J'ai apprécié chez Auriane son art du questionnement, me poussant à aller au-delà de ma propre réflexion et m'invitant à aborder tous les aspects d'un problème, grâce à la relation de confiance et de respect qu'elle a générée. Je la recommande vivement.",
    author: "Marie Lucas",
    context: "Directrice Talents Développement, membre du Codir Audit — KPMG France",
  },
  {
    quote:
      "I had the good fortune to have Auriane as coach when I was considering the next career step. Her professional approach, non-judgemental attitude, and sense of humour have helped catalyse my transition to independent consultant. You are an inspired coach!",
    author: "Doreen Wood",
    context: "VP Program Lead — ITM",
  },
  {
    quote:
      "Une grande profondeur et une grande patience dans l'analyse des talents et des qualités de chacun afin de chercher ensemble le meilleur projet de carrière. Surtout, un sens inné à mettre les personnes en contact, à susciter un réseau, à provoquer une fertilisation réciproque.",
    author: "Philippe Ngo Van",
    context: "Medical Director — Infectious Diseases",
  },
  {
    quote:
      "Ses grandes capacités d'écoute et sa bienveillance en font une vraie professionnelle qui sait vous faire avancer en tenant compte de vos propres impératifs. Je recommande vivement Auriane, également pour sa capacité à mettre en relation les uns et les autres de manière naturelle.",
    author: "Laurent Bujadoux",
    context: "Directeur Financier",
  },
  {
    quote:
      "Un grand merci Auriane pour ces moments et tes conseils ! Humaine, à l'écoute et enthousiaste — tout est dit.",
    author: "Yannick Marty",
    context: "Responsable Projet Amélioration Performance Supply Chain — Legrand",
  },
  {
    quote:
      "Dotée d'un sens aigu d'analyse des personnalités et de leurs compétences, Auriane est capable d'un discernement précis. Ses capacités relationnelles instaurent spontanément la sympathie et la confiance — qualités d'un excellent coach dont j'ai moi-même bénéficié pour une réorientation de carrière.",
    author: "Murielle Terlinden",
    context: "Réorientation de carrière",
  },
];

export const testimonialsEn = [
  {
    quote:
      "I had the privilege of having her as my coach for six months. Her remarkable ability to adapt with empathy, her method of guiding rather than handing over ready-made answers, greatly facilitated the implementation of our actions. An essential catalyst of my professional growth.",
    author: "Alexandre Piorunowski",
    context: "General Manager — Fidia Pharma",
  },
  {
    quote:
      "Attentive in her listening, with varied and formidably effective methods to help you rediscover every angle of your professional abilities. After 20 years of career, I had to define the next 20 with confidence — Auriane was an invaluable help.",
    author: "Bruno Latanicki",
    context: "Digital Project Director — Air Liquide",
  },
  {
    quote:
      "What I valued in Auriane is her art of questioning — pushing me beyond my own reflection and inviting me to address every aspect of a problem, thanks to the trusted, respectful relationship she built. I warmly recommend her.",
    author: "Marie Lucas",
    context: "Talent Development Director, Audit Codir — KPMG France",
  },
  {
    quote:
      "I had the good fortune to have Auriane as coach when I was considering the next career step. Her professional approach, non-judgemental attitude, and sense of humour have helped catalyse my transition to independent consultant. You are an inspired coach!",
    author: "Doreen Wood",
    context: "VP Program Lead — ITM",
  },
  {
    quote:
      "Great depth and great patience in analysing each person's talents and qualities, so as to search together for the best career project. And above all an innate sense for connecting people, sparking a network, provoking mutual fertilisation.",
    author: "Philippe Ngo Van",
    context: "Medical Director — Infectious Diseases",
  },
  {
    quote:
      "Her listening abilities and benevolence make her a true professional who knows how to move you forward while respecting your own constraints. I warmly recommend Auriane, also for her natural ability to connect people.",
    author: "Laurent Bujadoux",
    context: "Finance Director",
  },
  {
    quote:
      "A big thank you Auriane for these moments and your advice! Human, attentive, enthusiastic — that says it all.",
    author: "Yannick Marty",
    context: "Supply Chain Performance Improvement Lead — Legrand",
  },
  {
    quote:
      "Endowed with a keen sense of analysing personalities and competencies, Auriane shows precise discernment. Her relational qualities spontaneously inspire sympathy and trust — the qualities of an excellent coach from whom I myself benefited for a career reorientation.",
    author: "Murielle Terlinden",
    context: "Career reorientation",
  },
];
